import { cookiesNotice } from '../constant/Constant'
import { makeStyles } from '@mui/styles'
import { useCallback } from 'react'

export const usePolicyCore = () => {
    const policyLink = cookiesNotice.policyLink
    const onPolicyLinkClicked = useCallback(() => {
        globalThis.open(policyLink, 'policy')
    }, [])

    const classesStyle = makeStyles((theme) => ({
        policyLink: {
            color: '#fff',
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    }))()

    return {
        policyLinkCssClass: classesStyle,
        onPolicyLinkClicked,
    }
}
